import React from 'react';
import {IListColumnProps} from '../../../../src/@interfaces/components/List/IListColumnProps';
import {AttentionMessageProps} from './messages';
import {ListConfigNamedColumn} from '../../../../src/@types/components/List';
import InlineUserRepresentation from '../../../../src/components/CommentsList/InlineUserRepresentation';

export function CreatorColumn(props: IListColumnProps<ListConfigNamedColumn, AttentionMessageProps['model']>) {
    return props.model.creator ? <InlineUserRepresentation user={props.model.creator}/> : <>—</>;
}
